document.addEventListener('DOMContentLoaded', (): void => {
    const tables = document.querySelectorAll('.rte-content table') as NodeListOf<HTMLTableElement>;

    tables.forEach((table: HTMLTableElement): void => {
        if (table.dataset.rteBootstrapped === '1') return;

        table.style.removeProperty('min-width');

        const colGroups = table.querySelectorAll('colgroup, col') as NodeListOf<HTMLElement>;
        colGroups.forEach((colGroup: HTMLElement): void => colGroup.remove());

        const elementsWithColWidth = table.querySelectorAll('[colwidth]') as NodeListOf<HTMLElement>;
        elementsWithColWidth.forEach((element: HTMLElement): void => element.removeAttribute('colwidth'));

        table.classList.add('table', 'table-striped', 'table-bordered', 'table-sm');

        const parentElement = table.parentElement;
        if (parentElement && !parentElement.classList.contains('table-responsive')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'table-responsive';

            const parentNode = table.parentNode;
            if (parentNode) {
                parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        }

        table.dataset.rteBootstrapped = '1';
    });
});